import { m as merge, z as getComponentFromVNode, A as copyAppContext, _ as _defineProperty } from './helpers-O9h6_ICO.js';
import { _ as _createClass, a as _classCallCheck } from './classCallCheck-E4khD9xn.js';
import { createApp, h } from 'vue';
import { s as script } from './Loading-p2sa5IKE.js';
import { a as registerComponent, r as registerComponentProgrammatic } from './plugins-C7548x21.js';
import './typeof-Z4rCTFCZ.js';
import './ssr-jg9-YOst.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var LoadingProgrammatic = /*#__PURE__*/function () {
  function LoadingProgrammatic(app) {
    _classCallCheck(this, LoadingProgrammatic);
    this.app = app; // may be undefined in the testing environment
  }
  _createClass(LoadingProgrammatic, [{
    key: "open",
    value: function open(params) {
      var defaultParam = {
        programmatic: true
      };
      var propsData = merge(defaultParam, params);
      var container = document.createElement('div');
      // Vue 3 requires a new app to mount another component
      var vueInstance = createApp({
        data: function data() {
          return {
            loadingVNode: null
          };
        },
        methods: {
          close: function close() {
            // TODO: too much dependence on Vue's internal structure?
            var loading = getComponentFromVNode(this.loadingVNode);
            if (loading) {
              loading.close();
            }
          }
        },
        render: function render() {
          this.loadingVNode = h(script, _objectSpread(_objectSpread({}, propsData), {}, {
            onClose: function onClose() {
              if (propsData.onClose) {
                propsData.onClose.apply(propsData, arguments);
              }
              // timeout for the animation complete before destroying
              setTimeout(function () {
                vueInstance.unmount();
              }, 150);
            }
          }));
          return this.loadingVNode;
        }
      });
      if (this.app) {
        copyAppContext(this.app, vueInstance);
      }
      return vueInstance.mount(container);
    }
  }]);
  return LoadingProgrammatic;
}();
var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, script);
    registerComponentProgrammatic(Vue, 'loading', new LoadingProgrammatic(Vue));
  }
};

export { script as BLoading, LoadingProgrammatic, Plugin as default };
